import { ReactNode } from 'react';
import { styled } from '@mui/material/styles';

export const SectionHeader = ({
  title,
  action,
  className,
}: {
  title: ReactNode;
  action?: ReactNode;
  className?: string;
}) => {
  return (
    <HeaderRoot className={className}>
      <div>{title}</div>
      {action ? <div>{action}</div> : null}
    </HeaderRoot>
  );
};

export const SectionBody = styled('div')<{ minHeight?: number }>(
  ({ minHeight }) => ({
    display: 'flex',
    gap: '26px',
    overflowY: 'auto',
    minHeight: minHeight || 'auto',

    '> div': {
      flexShrink: 0,
      alignSelf: 'center',
    },
  }),
);

const HeaderRoot = styled('div')(({ theme }) => ({
  color: theme.palette.grey900,
  fontSize: 18,
  fontWeight: 600,
  lineHeight: '28px',
  margin: '26px 0',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

